<template>
  <div class="evaluation-list">
    <div class="list-table__title">Observation</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="evaluations"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #cell(tutorId)="evaluation">
        <router-link :to="{name:'TutorDetail' , params: { id: evaluation.item.tutorId }}">
          {{ evaluation.value }}
        </router-link>
      </template>
      <template #cell(tutorName)="evaluation">
        <router-link :to="{name:'TutorDetail' , params: { id: evaluation.item.tutorId }}">
          {{ evaluation.value }}
        </router-link>
      </template>
      <template #cell(Detail)="evaluation">
        <div>
          <DetailBtn :link="{
            name:'EvaluationDetail',
            params: {
              tutorId: evaluation.item.tutorId,
              evaluationId: evaluation.item.evaluationId,
              fiscalYear: evaluation.item.fiscalYear,
            }
          }"/>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import DetailBtn from '@/components/parts/DetailBtn.vue';

export default {
  data() {
    return {
      fields: [
        {
          key: 'tutorId',
          label: 'Tutor ID',
          sortable: true,
        },
        {
          key: 'tutorName',
          label: 'Tutor Name',
        },
        {
          key: 'fiscalYear',
          label: 'Year',
        },
        {
          key: 'position',
          label: 'Position',
        },
        {
          key: 'score',
          label: 'Score',
        },
        { key: 'Detail' },
      ],
    };
  },

  components: {
    DetailBtn,
  },

  props: {
    evaluations: Array,
  },
}
</script>

<style>
.evaluation-list .list-table .list-table__head {
  font-size: .8rem;
}

.evaluation-list .list-table .list-table__body td {
  font-size: .8rem;
  padding: 1rem;
}
</style>

<style scoped>
  .detail-button {
    display: block;
    text-decoration: none;
    color: #000;
    padding: 10px;
    border: 2px solid #AAAFB6;
    border-radius: 20px;
    cursor: pointer;
  };

  .detail-button:hover {
    background: #000;
  };
</style>
